import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiPhone, FiMail, FiMapPin, FiClock, FiLinkedin, FiTwitter } = FiIcons;

function Footer() {
  return (
    <footer className="bg-navy-800 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 lg:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <div className="bg-gold-600 p-2 rounded-lg">
                <svg className="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2L2 7v10c0 5.55 3.84 9.74 9 11 5.16-1.26 9-5.45 9-11V7l-10-5z"/>
                  <path d="M9 12l2 2 4-4" stroke="white" strokeWidth="2" fill="none"/>
                </svg>
              </div>
              <div>
                <h3 className="font-opensans font-bold text-lg">
                  Given Ndlovu & Thibela
                </h3>
                <p className="font-opensans text-sm" style={{ color: '#FFB002' }}>Attorneys</p>
              </div>
            </div>
            <p className="font-opensans text-gray-300 mb-4 max-w-md">
              Over 25 years of dedicated legal service to corporations and individuals across Gauteng. We combine deep legal expertise with a commitment to understanding our clients' unique needs.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-300 hover:text-gold-600 transition-colors">
                <SafeIcon icon={FiLinkedin} className="w-5 h-5" />
              </a>
              <a href="#" className="text-gray-300 hover:text-gold-600 transition-colors">
                <SafeIcon icon={FiTwitter} className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-opensans font-semibold text-lg mb-4">Quick Links</h4>
            <ul className="space-y-2 font-opensans">
              <li><Link to="/about" className="text-gray-300 hover:text-gold-600 transition-colors">About Us</Link></li>
              <li><Link to="/services" className="text-gray-300 hover:text-gold-600 transition-colors">Our Services</Link></li>
              <li><Link to="/attorneys" className="text-gray-300 hover:text-gold-600 transition-colors">Our Team</Link></li>
              <li><Link to="/blog" className="text-gray-300 hover:text-gold-600 transition-colors">Legal Insights</Link></li>
              <li><Link to="/contact" className="text-gray-300 hover:text-gold-600 transition-colors">Contact Us</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-opensans font-semibold text-lg mb-4">Contact Info</h4>
            <div className="space-y-3 font-opensans text-gray-300">
              <div className="flex items-start space-x-3">
                <SafeIcon icon={FiMapPin} className="w-5 h-5 mt-1 text-gold-600" />
                <div>
                  <p>15th Floor, Sandton City Office Tower</p>
                  <p>Corner 5th Street & Alice Lane</p>
                  <p>Sandton, 2196, Johannesburg</p>
                </div>
              </div>
              <div className="flex items-center space-x-3">
                <SafeIcon icon={FiPhone} className="w-5 h-5 text-gold-600" />
                <span>+27 11 123 4567</span>
              </div>
              <div className="flex items-center space-x-3">
                <SafeIcon icon={FiMail} className="w-5 h-5 text-gold-600" />
                <span>law@gnt.co.za</span>
              </div>
              <div className="flex items-center space-x-3">
                <SafeIcon icon={FiClock} className="w-5 h-5 text-gold-600" />
                <span>Mon-Fri: 08:00-17:00</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="font-opensans text-gray-300 text-sm">
              © 2024 Given Ndlovu & Thibela Attorneys. All rights reserved.
            </p>
            <div className="flex space-x-6 mt-4 md:mt-0 items-center">
              <a href="#" className="font-opensans text-gray-300 hover:text-gold-600 text-sm transition-colors">
                Privacy Policy
              </a>
              <a href="#" className="font-opensans text-gray-300 hover:text-gold-600 text-sm transition-colors">
                Terms of Service
              </a>
              <a 
                href="https://www.primehost.co.za/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="font-opensans text-sm transition-colors"
                style={{ color: '#FFC600' }}
                onMouseEnter={(e) => e.target.style.color = '#FFB002'}
                onMouseLeave={(e) => e.target.style.color = '#FFC600'}
              >
                Website by Primehost
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;